// US federal holidays computed deterministically per-year so we don't need
// to maintain a static table that ages out. Each holiday is given a stable
// `id` of the form `<slug>-<yyyy>` so dismissals persist across reloads.

function nthDow(year, monthIdx, dow, n) {
  // monthIdx: 0-based, dow: 0=Sun..6=Sat, n: 1..5
  var first = new Date(year, monthIdx, 1);
  var offset = (dow - first.getDay() + 7) % 7;
  var day = 1 + offset + (n - 1) * 7;
  return new Date(year, monthIdx, day);
}

function lastDow(year, monthIdx, dow) {
  // Last <dow> of a month — start from day 28 and walk forward.
  var last = new Date(year, monthIdx + 1, 0); // last day of month
  var offset = (last.getDay() - dow + 7) % 7;
  return new Date(year, monthIdx, last.getDate() - offset);
}

function iso(d) {
  var y = d.getFullYear();
  var m = String(d.getMonth() + 1).padStart(2, '0');
  var dd = String(d.getDate()).padStart(2, '0');
  return y + '-' + m + '-' + dd;
}

// Returns all US federal holidays for the requested year.
// Each entry: { id, slug, name, date (yyyy-mm-dd) }.
export function getFederalHolidaysForYear(year) {
  var list = [
    { slug: 'new-years-day',   name: "New Year's Day",     date: iso(new Date(year, 0, 1)) },
    { slug: 'mlk-day',         name: 'Martin Luther King Jr. Day', date: iso(nthDow(year, 0, 1, 3)) },
    { slug: 'presidents-day',  name: "Presidents' Day",    date: iso(nthDow(year, 1, 1, 3)) },
    { slug: 'memorial-day',    name: 'Memorial Day',       date: iso(lastDow(year, 4, 1)) },
    { slug: 'juneteenth',      name: 'Juneteenth',         date: iso(new Date(year, 5, 19)) },
    { slug: 'independence-day',name: 'Independence Day',   date: iso(new Date(year, 6, 4)) },
    { slug: 'labor-day',       name: 'Labor Day',          date: iso(nthDow(year, 8, 1, 1)) },
    { slug: 'columbus-day',    name: 'Columbus Day',       date: iso(nthDow(year, 9, 1, 2)) },
    { slug: 'veterans-day',    name: 'Veterans Day',       date: iso(new Date(year, 10, 11)) },
    { slug: 'thanksgiving',    name: 'Thanksgiving Day',   date: iso(nthDow(year, 10, 4, 4)) },
    { slug: 'christmas-day',   name: 'Christmas Day',      date: iso(new Date(year, 11, 25)) },
  ];
  return list.map(function (h) {
    return { id: h.slug + '-' + year, slug: h.slug, name: h.name, date: h.date };
  });
}

// Returns all federal holidays spanning [yearStart, yearEnd], filtering out any
// IDs the user has dismissed. Result is a map keyed by `yyyy-mm-dd` for O(1)
// lookup from the calendar grid.
export function getHolidayMap(yearStart, yearEnd, dismissedIds) {
  var dismissed = new Set(dismissedIds || []);
  var byDate = {};
  for (var y = yearStart; y <= yearEnd; y++) {
    getFederalHolidaysForYear(y).forEach(function (h) {
      if (dismissed.has(h.id)) return;
      byDate[h.date] = h;
    });
  }
  return byDate;
}
